import { render, staticRenderFns } from "./VSelectPT.vue?vue&type=template&id=fd2a292a"
import script from "./VSelectPT.vue?vue&type=script&lang=js"
export * from "./VSelectPT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports